import type { FeaturePageSeo } from "@/components/feature-template/seo";
import type { FAQItem } from "@/components/feature-template/types";

// Shared by page.tsx (JSON-LD) and the client page (visible FAQ) so both always match.

export const faqs: FAQItem[] = [
  {
    question: "What does a Jobs Deep Research report include?",
    answer:
      "A company snapshot (size, stage, funding, tech stack and leadership), recent news, employee sentiment, the typical interview process, salary bands by level and a short interview brief with talking points.",
  },
  {
    question: "Where does the information come from?",
    answer:
      "Reports combine public sources such as company announcements, news coverage, job postings and published employee reviews. Each section notes when figures are estimates.",
  },
  {
    question: "How accurate are the salary bands?",
    answer:
      "Bands are estimates built from public postings and reported pay for the same role, level and city. Use them as a negotiation reference, not a guarantee of what a company will offer.",
  },
  {
    question: "Can I see the interview process for a specific role?",
    answer:
      "Yes. Research a role and you get the usual rounds, typical timeline and the topics each round tends to cover, so you can prepare for each stage separately.",
  },
  {
    question: "How does research help me in the interview itself?",
    answer:
      "The interview brief turns the research into talking points that link your experience to the company's current priorities, plus thoughtful questions to ask your interviewers.",
  },
  {
    question: "Can I practise with the research?",
    answer:
      "Yes. From any round in the interview process you can start an AI mock interview focused on that round's topics.",
  },
  {
    question: "How often is company data refreshed?",
    answer:
      "News, open roles and hiring signals are refreshed regularly. Each report shows when it was last updated.",
  },
];

export const seo: FeaturePageSeo = {
  slug: "jobs-deep-research",
  name: "Jobs Deep Research",
  title: "Company Research Before You Apply | MindMyJob",
  description:
    "Research any company before you apply: culture, interview process, salary bands, hiring momentum and talking points for your interview, in one report.",
  keywords: [
    "company research tool",
    "research a company before interview",
    "company interview process",
    "salary bands by level",
    "company culture reviews",
    "hiring trends by company",
    "interview preparation",
    "questions to ask interviewer",
    "company insights for job seekers",
    "employer research",
  ],
  ogImage:
    "/assets/images/features/jobs-deep-research/hero-company-snapshot.png",
  ogImageAlt:
    "MindMyJob Jobs Deep Research company snapshot with headcount, funding, news and leadership",
  featureList: [
    "Company snapshot with funding, size and tech stack",
    "Recent company news",
    "Interview rounds and timeline",
    "Salary bands by level and city",
    "Employee sentiment and reviews",
    "Hiring momentum and health signals",
    "Interview brief with talking points",
  ],
  faqs,
};
